export class UrlHelper {
  static isSafeHttpUrl(url: string): boolean {
    try {
      const parsedUrl = new URL(url);
      return ['http:', 'https:'].includes(parsedUrl.protocol);
    } catch (error) {
      return false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/core/helpers/uri.helper.ts